import React, { useMemo } from 'react'

import dayjs from 'dayjs'
import { FiCamera } from 'react-icons/fi'
import { TbPhotoVideo } from 'react-icons/tb'

import { useChallenge, useUser } from '../../../context'
import { ChallengeStatus, ChallengeVisibility } from '../../../types'
import {
  capitalizeFirstLetter,
  translateStatus,
} from '../../../utilFunctions/transformFunc'
import { parseDate } from '../../lists/Challenges/ChallengesList'
import PlainCard from '../PlainCard'

import {
  PreviewBadge,
  PreviewBadgesContainer,
  PreviewCard,
  PreviewHashtags,
  PreviewImage,
  PreviewMeta,
  PreviewTitle,
  TitleContainer,
} from './styles'

const ChaPreviewCard = () => {
  const { formState } = useChallenge()
  const { onEditionMode, userRole } = useUser()

  const formatRange = () => {
    if (!formState.startDate && !formState.endDate) return ''
    const fmt = (d: string) => (d ? d.split('-').join('.') : '')
    return `${fmt(formState.startDate)}  –  ${fmt(formState.endDate)}`
  }

  const icon = formState.category === 'Reels' ? <TbPhotoVideo /> : <FiCamera />

  const computeStatus = useMemo(() => {
    const start = parseDate(formState.startDate)
    const end = parseDate(formState.endDate)
    const today = dayjs().startOf('day')

    if (start?.isValid() && today.isBefore(start, 'day')) {
      return ChallengeStatus.UPCOMING
    }
    if (end?.isValid() && today.isAfter(end, 'day')) {
      return ChallengeStatus.ENDED
    }
    return ChallengeStatus.ACTIVE
  }, [formState.startDate, formState.endDate])

  const badgeLabel = useMemo(() => {
    return translateStatus(computeStatus)
  }, [computeStatus])

  return (
    <PlainCard
      key="challenge-preview"
      title={onEditionMode ? 'Vista previa' : ''}
    >
      <PreviewCard>
        {formState.image ? (
          <PreviewImage src={formState.image} alt={formState.altText} />
        ) : (
          <PreviewImage
            as="div"
            style={{
              background: 'linear-gradient(135deg,#111827,#334155)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: 14,
            }}
          >
            Portada del desafío
          </PreviewImage>
        )}

        <PreviewBadgesContainer>
          {userRole === 'admin' && (
            <PreviewBadge
              $status={computeStatus}
              $visibility={formState.visibility}
              className="visibility"
            >
              {capitalizeFirstLetter(
                formState.visibility
                  ? ChallengeVisibility.VISIBLE
                  : ChallengeVisibility.HIDDEN,
              )}
            </PreviewBadge>
          )}
          <PreviewBadge
            $status={computeStatus}
            $visibility={formState.visibility}
            className="status"
          >
            {badgeLabel}
          </PreviewBadge>
        </PreviewBadgesContainer>

        <TitleContainer>
          <div>{icon}</div>
          <div>
            <PreviewTitle>
              {formState.title || 'Título del desafío'}
            </PreviewTitle>
            <PreviewMeta>{formatRange()}</PreviewMeta>
          </div>
        </TitleContainer>

        <PreviewMeta>{formState.description}</PreviewMeta>
        <PreviewHashtags>
          {formState.hashtags.map((tag) => `#${tag}`).join(' ')}
        </PreviewHashtags>
      </PreviewCard>
    </PlainCard>
  )
}

export default ChaPreviewCard
